const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/zgks/eCheckin/sections/KontaktPerson.tsx';
import * as React from 'react';
import { forwardRef } from 'react';
import { useCIS4m, useCIS4mData } from '@cistec/common_web/modules/CIS4m/hooks';
import textMap from '../translations';
import { CIS4mTextField } from '@cistec/common_web/modules/CIS4m/components/CIS4mTextField';
import textMapCommon from '../../../common/translations';
import { AddressBlock, AddressFieldsConfig } from 'App/components/eCheckin/components/fields/AddressBlock';
import { ECheckinSectionProps } from 'App/components/eCheckin/types';
import { CIS4mPhoneNumberField } from '@cistec/common_web/modules/CIS4m/components/CIS4mPhoneNumberField';
import { validatePhoneNumber } from '@cistec/common_web/components/Forms/utils/validation';
import ECheckinSection from 'App/components/eCheckin/components/ECheckinSection';
import { CIS4mBlock } from '@cistec/common_web/modules/CIS4m/components/CIS4mBlock';
import CIS4mSingleCheckbox from '@cistec/common_web/modules/CIS4m/components/CIS4mSingleCheckbox';
import _ from 'lodash';
import { BeziehungField } from 'App/components/eCheckin/components/fields/metakat/BeziehungField';
import { createFieldPath } from 'App/components/eCheckin/utils';
import { AnredeField } from 'App/components/eCheckin/components/fields/metakat/AnredeField';
import { useText } from '@cistec/common_web/utils/intlUtils';

const addressFieldsConfig: AddressFieldsConfig = {
    additionalInfo: { included: false },
    streetAndNumber: { required: false },
    country: { included: false },
};

export const KontaktPerson = forwardRef((props: ECheckinSectionProps, ref: any) => {
    const { path } = props;
    const title = useText(props.title);

    const PATH_KEINE_ANGABEN = createFieldPath(path, 'keineAngaben');
    const PATH_BEZIEHUNG = createFieldPath(path, 'beziehung');
    const PATH_ANREDE = createFieldPath(path, 'anrede');

    const PATH_FIRST_NAME = createFieldPath(path, 'firstname');
    const PATH_LAST_NAME = createFieldPath(path, 'lastname');
    const PATH_TEL = createFieldPath(path, 'tel');

    const formData = useCIS4mData();
    const keineAngaben = _.get(formData, PATH_KEINE_ANGABEN) === '1';

    const eCheckinSectionRef = useCIS4m(ref);

    return (
        <ECheckinSection ref={eCheckinSectionRef} path={path} title={title}>
            <h1>{title}</h1>
            <CIS4mSingleCheckbox label={textMap.keineAngaben} path={PATH_KEINE_ANGABEN} />
            <CIS4mBlock hidden={keineAngaben}>
                <BeziehungField label={textMap.beziehung} path={PATH_BEZIEHUNG} required={true} />
                <AnredeField label={textMap.anrede} path={PATH_ANREDE} required={true} />
                <CIS4mTextField label={textMapCommon.firstname} path={PATH_FIRST_NAME} required={true} />
                <CIS4mTextField label={textMapCommon.lastname} path={PATH_LAST_NAME} required={true} />

                <AddressBlock basePath={path} required={true} fieldsConfig={addressFieldsConfig} />
                <CIS4mPhoneNumberField
                    label={textMapCommon.tel}
                    path={PATH_TEL}
                    required={true}
                    checkValidity={validatePhoneNumber}
                />
            </CIS4mBlock>
        </ECheckinSection>
    );
});

KontaktPerson.displayName = 'KontaktPerson';

export default KontaktPerson;
